import React from "react"
import "./styles.css";
import { Breadcrumb } from "../../Components/Atoms";
import PATHS from "../../Routes/paths";
import ViewRoutes from "../ViewRoutes";

const ArchivedRoutes = () => {
  const breadcrumbPaths = [
    { idx: 1, name: "View Routes", link: PATHS.VIEW_ROUTES },
    { idx: 2, name: "Archived Routes", isCurrentPage: true },
  ];

  return (
    <div className="panel-main archived-routes">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>
      <p className="archived-routes-note">These routes were automatically archived when they were edited and replaced with a new version. Archived routes are retained only for reference and no longer apply to current deviations.</p>
      <ViewRoutes archived={true} />
    </div>
  )
}

export default ArchivedRoutes
